import loadable from '@loadable/component';

const SubmitPageLoadable = loadable(() => import('./SubmitPage'), {
  fallback: <div>loading</div>,
});

export default SubmitPageLoadable;
